// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"42b4a83bd344f5007f37","418":"01f589cb48539c2dcc2f","661":"605e0798f43f2246a2a6"}[chunkId] + ".bundle.js";
};